<template>
  <el-input :style="`width:${width}`" :size="size" v-model="value" @keyup.native.enter="search" placeholder="검색 키워드 입력">
    <span class="el-input__icon" slot="suffix">
      <i class="el-icon-circle-close c-pointer" style="margin-right:4px;" v-show="!isEmptyValue" @click="clear"></i>
      <i class="el-input__icon el-icon-search c-pointer" style="margin-right:4px;" @click="search"></i>
    </span>
 </el-input>
</template>

<script>
export default {
  name: 'WSearchField',
  props: {
    size: {
      type: String,
      default: 'mini',
    },
    width: {
      type: String,
      default: '100%',
    },
    inputSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: null,
    };
  },
  computed: {
    isEmptyValue() {
      return this.value === undefined || this.value === null || this.value === '';
    },
  },
  watch: {
    value() {
      if (this.inputSearch === true) {
        this.search();
      }
    },
  },
  methods: {
    search() {
      this.$emit('search', this.value);
    },
    clear() {
      this.value = '';
      this.search();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/form/SearchField.vue